import { call, put, takeEvery } from 'redux-saga/effects';
import { getCapModels } from '../../../requests/cap_requests/get_cap_models_request';
import { getLeadsCapModelsRequestSuccess, getLeadsCapModelsRequestFailure } from '../../actions/cap_actions/get_cap_models.actions';
import { GET_LEADS_CAP_MODELS_REQUEST } from '../../constants/cap.constants';
import { message_error } from '../../../../../../components/Message';

function* getCapModelsRequest({ brand_id }) {
    const { result, options, error } = yield call(getCapModels, brand_id);
    if (result) {
        yield put(getLeadsCapModelsRequestSuccess(options));
    } else {
        yield put(getLeadsCapModelsRequestFailure(error));
        message_error(error);
    }
}

export default function* getCapModelsSaga() {
    yield takeEvery(GET_LEADS_CAP_MODELS_REQUEST, getCapModelsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/cap.sagas/get_cap_models.saga.js